import { CommandBase } from "~app/common/services/cqs/commandManager";
import { CommandSendType } from "~app/common/services/cqs/CommandType";

export class UpdateAnvandareVikarieCommand extends CommandBase {
    id: number;
    vikarieId: number;
    franDatum: string;
    tillDatum: string;
    $type: string;
    $commandSendType: CommandSendType;

    constructor(init: (instance: UpdateAnvandareVikarieCommand) => void) {
        super("CreateAnvandareVikarieCommand");
        init(this);
    }

}
